import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItem {
  question: string;
  answer: string;
}
interface FAQAccordionProps {
  items: FAQItem[];
}
export function FAQAccordion({
  items
}: FAQAccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const toggleItem = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="w-full max-w-3xl mx-auto space-y-4" data-id="element-37">
      {items.map((item, index) => <div key={index} className="border border-bordercolor rounded-lg bg-surface overflow-hidden shadow-subtle" data-id="element-38">
          <button onClick={() => toggleItem(index)} className="w-full flex items-center justify-between p-5 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-opacity-50 transition-colors hover:bg-gray-50" aria-expanded={openIndex === index} data-id="element-39">
            <span className="font-medium text-brandtext" data-id="element-40">{item.question}</span>
            <motion.div animate={{
          rotate: openIndex === index ? 180 : 0
        }} transition={{
          duration: 0.2,
          ease: 'easeInOut'
        }} data-id="element-41">
              <ChevronDownIcon className="w-5 h-5 text-primary" data-id="element-42" />
            </motion.div>
          </button>

          <AnimatePresence initial={false} data-id="element-43">
            {openIndex === index && <motion.div initial={{
          height: 0,
          opacity: 0
        }} animate={{
          height: 'auto',
          opacity: 1
        }} exit={{
          height: 0,
          opacity: 0
        }} transition={{
          duration: 0.3,
          ease: 'easeInOut'
        }} data-id="element-44">
                <div className="p-5 pt-0 text-brandtext-muted border-t border-gray-100 leading-relaxed" data-id="element-45">
                  {item.answer}
                </div>
              </motion.div>}
          </AnimatePresence>
        </div>)}
    </div>;
}